module.exports = __webpack_public_path__ + "img/social.c4472233.svg";